module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_up_small-956b8b23c8a692c9ff6134f1d7c71a67.svg";